<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path d="M17 9l-5-5-5 5z" :class="{ on: !up }" />
    <path d="M7 15l5 5 5-5z" :class="{ on: !down }" />
  </svg>
</template>

<script>
export default {
  name: 'SortIcon',
  props: {
    up: { type: Boolean, default: false },
    down: { type: Boolean, default: false },
  },
}
</script>

<style lang="postcss" scoped>
.on {
  fill: var(--dark-gray);
}
</style>
